const EmptyTailoredGenerationIcon = () => (
	<svg width="35" height="39" viewBox="0 0 35 39" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.366 5.5H1.5V37.5H27.5V21.5M19.5 29.5H9.5M21.5 5.5V1.5M27.5 7.5L31.5 3.5M29.5 13.5H33.5M9.5 21.5H19.5V13.5H9.5V21.5Z"
			stroke="#5B5B5B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default EmptyTailoredGenerationIcon;
